import React from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import Constants from '../App/Variables/Constants';
import "bootstrap/dist/css/bootstrap.min.css";
import "./SvgCss/ColorChange.css";

const MainFabric = ({ getMainFabric, setMainFabricId, mainFabricId, setBgColor, setFabricImage, canvasWidth, canvasHeight }) => {
    
  const FabricType = [
    { id: 1, value: "velvet", label: "Velvet" },
    { id: 2, value: "genuin_leather", label: "Genuin Leather" },
    { id: 3, value: "cowhide", label: "Cowhide" },
    { id: 4, value: "exotic_leather", label: "Exotic Leather" },
    { id: 5, value: "linen", label: "Linen" },
  ];


    const getFabric = (e, main_fabric_id) => {
        // setMainFabricColor("");
        setMainFabricId(main_fabric_id);
        setBgColor("white"); // Set background color
        const img = new window.Image();
        img.crossOrigin = "Anonymous";
        img.src = e;

        img.onload = () => {
            setFabricImage((prevImages) => [
                // ...prevImages,
                {
                    id: `imagess-${prevImages.length}`, // Use a unique ID
                    image: img,
                    x: 0,
                    y: 0,
                    width: canvasWidth,
                    height: canvasHeight,
                },
            ]);
        };

        img.onerror = () => {
            console.error("Image failed to load:", e);
        };
    };

    return (<>
        <div 
            className="row flex-column border border-3 border-dark overflow-hidden rounded-5 my-3"
            style={{ backgroundColor: "white" }}
        >
            <div className="col-12">
                <div className="row flex-column gap-4 py-4">
                    {Object.keys(getMainFabric).length > 0 ? (
                        <Tabs
                            id="fabric-tabs"
                            className="mb-3"
                            style={{ flexWrap: "nowrap" }}
                        >
                            {FabricType.map((fabricGroup, i) => (
                                <Tab
                                    key={i + 2}
                                    color='primary'
                                    eventKey={fabricGroup.label} title={<span style={{ fontSize: "1rem" }}>{fabricGroup.label}</span>}
                                    >
                                    {getMainFabric[fabricGroup.value].length > 0 ? ( // Check fabrics length for the group
                                        <div className="d-flex flex-wrap gap-2">
                                            {getMainFabric[fabricGroup.value].map((fabric, j) => (
                                                <img
                                                    key={j}
                                                    style={{ width: "80px", display: "inline", cursor: "pointer" }}
                                                    // className="img-fluid"
                                                    className={` ${mainFabricId === fabric._id
                                                        ? "mainfabric-selected"
                                                        : ""
                                                        }`}
                                                    src={Constants.imgDomain + fabric.image} // Use the correct image property
                                                    onClick={() =>
                                                        getFabric(
                                                            Constants.imgDomain + fabric.image,
                                                            fabric._id
                                                        )
                                                    } // Assuming getFabric takes an id
                                                    alt={fabric.name} // Use fabric name for alt text
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <p style={{ color: "black" }}>No fabrics available in this category.</p>
                                    )}
                                </Tab>
                            ))}
                        </Tabs>
                    ) : (
                        <p>Loading fabrics...</p>
                    )}
                </div>
            </div>
        </div>
    </>)
}

export default MainFabric